export default {
    BASE_API: 'https://api.just-id.com',
    LINE_REDIRECT_URI: "https://card.just-id.com/line-callback",
    LINE_CLIENT_ID: "1654259658",
    LINE_CLIENT_SECRET: "60e7c24f895ea504332b8f4a62511d46",
}